import trans from '../../../trans'

class TournamentTemplate {
  titleLabel: string
  finishDateLabel: string
  rewardLabel: string
  pointsLabel: string
  rankLabel: string
  nameLabel: string
  showMoreLabel: string
  subscribeLabel: string
  noClassifiedUsersYet: string

  constructor() {
    this.titleLabel = trans('tournaments_label')
    this.rewardLabel = trans('reward')
    this.nameLabel = trans('name')
    this.showMoreLabel = trans('show_more')
    this.pointsLabel = trans('score')
    this.rankLabel = trans('position')
    this.finishDateLabel = trans('finish_date')
    this.subscribeLabel = trans('subscribe_tournament_label')
    this.noClassifiedUsersYet = trans('no_classified_users_yet')
  }

  getHTMLElement() {
    const element = document.createElement('div')
    element.innerHTML = this.getLiteralTemplate()

    return element
  }

  getLiteralTemplate() {
    return `
      <div class="tournament" data-tournament="container">
        <div class="toggle" data-tournament="toggle"  title="${this.titleLabel}">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xml:space="preserve"
            width="64"
            height="64"
            viewBox="0 0 10000 9000"
            preserveAspectRatio="xMinYMin meet"
            style="fill-rule: evenodd">
            <path d="M5436.846 6989.016v1169.29h416.46c752.83 0 1715.347 385.88 1715.347 856.218H2431.347c0-470.337 962.517-856.218 1715.348-856.218h416.46v-1169.29c-1258.116-77.176-2262.862-1129.974-2262.862-2407.02V3517.548C1397.48 3383.582 11.222 2847.718 11.222 1449.812c0-781.954 803.796-1416.836 1416.836-1416.836s838.744 203.861 1099.395 522.758h4945.094c260.651-318.897 486.355-522.758 1099.395-522.758s1416.836 634.882 1416.836 1416.836c0 1397.906-1386.257 1933.77-2289.071 2067.736v1064.448c0 1277.045-1004.746 2329.844-2262.861 2407.02zm2262.86-4324.773v-940.674c177.651-438.302 455.776-850.394 872.236-834.376 310.16 0 560.619 250.458 560.619 560.619 0 298.511-106.3 522.759-330.547 719.34-199.493 174.737-645.075 381.511-1102.307 495.091zm-5399.413 0v-940.674c-177.65-438.302-455.775-850.394-872.235-834.376-310.16 0-560.619 250.458-560.619 560.619 0 298.511 106.3 522.759 330.547 719.34 199.493 174.737 645.075 381.511 1102.307 495.091z"></path>
          </svg>
        </div>
        <div class="wrapper" data-tournament="wrapper">
          <div class="header">
            <div class="container">
              <span class="name" data-tournament="name"></span>
              <div class="close" data-tournament="close">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 26 26">
                  <path d="M16.7 13.4a.6.6 0 0 1 0-.8l9-9a1 1 0 0 0 0-1.6L24 .4a1.3 1.3 0 0 0-.8-.4 1 1 0 0 0-1 .4l-8.8 9a.6.6 0 0 1-.8 0l-9-9A1 1 0 0 0 2 .4L.4 2a1 1 0 0 0 0 1.7l9 9a.6.6 0 0 1 0 .7l-9 9a1 1 0 0 0 0 1.6L2 25.6a1 1 0 0 0 1.7 0l9-9a.6.6 0 0 1 .7 0l9 9a1 1 0 0 0 1.6 0l1.6-1.6a1 1 0 0 0 0-1.7z" />
                </svg>
            </div>
            </div>
            <span class="finishDate">
              <span>${this.finishDateLabel}: </span>
              <span class="finishDateValue" data-tournament="finishDate"></span>
            </span>
            <button class="btn big subscribe" data-tournament="subscribe">
              ${this.subscribeLabel}
            </button>
          </div>
            <div class="table-container" >
              <table class="table" data-tournament="tableContainer">
                <thead>
                  <tr>
                    <th>${this.rankLabel}</th>
                    <th>${this.nameLabel}</th>
                    <th>${this.pointsLabel}</th>
                    <th>${this.rewardLabel}</th>
                  </tr>
                </thead>
                <tbody data-tournament="tbody">
                  <tr>
                    <th colspan="4">
                      <p class="gray">${this.noClassifiedUsersYet}</p>
                    </th>
                  </tr>
                </tbody>
              </table>
          </div>
        </div>
    </div>
  `.trim()
  }
}

export default TournamentTemplate
